<template>
    <div>
        <notifications position="top center" group="info" />

		<h1>Bande passante</h1>

		<BarChart v-if="bandwidth" :chartData="bandwidth"></BarChart>
		<div v-if="bandwidth">Total : {{ bandwidth_sum.toFixed(2) }} mo</div>
		<BarChart v-if="editor_bandwidth" :chartData="editor_bandwidth"></BarChart>
		<div v-if="editor_bandwidth">Total : {{ editor_bandwidth_sum.toFixed(2) }} mo</div>

		<h1>Opération sur le client</h1>

		<b-button @click="generate_last_treatments">Générer les derniers traitements par projets</b-button>

        <h1>Stats générales</h1>

		<b-form-select v-model="client" :options="clients_name" @change="getClients"></b-form-select> 

		<div v-if="print">

			<h2>Worker</h2>

			<div v-if="steps">
				<b-table striped hover :items="steps" :fields="[
					{
						key: 'name',
						label: 'Nom',
						sortable: true
					},
					{
						key: 'value',
						label: 'Occurences',
						sortable: true
					}
				]">
				</b-table>
			</div>

			<div v-if="steps_scenario">
				<h2>Etapes - scénarios</h2>
				<b-table striped hover :items="steps_scenario" :fields="[
					{
						key: 'studio_name',
						label: 'Nom',
						sortable: true
					},
					{
						key: 'worker',
						label: 'Worker',
						sortable: true
					},
					{
						key: 'value',
						label: 'Occurences',
						sortable: true
					}
				]">
				</b-table>
			</div>

			<h2>Projets clients</h2>

			<div v-for="(client, idx) in clients" :key='idx'>
				<div v-if="client.projects">
					<h3>{{client.nom}}</h3>
					
					<b-table striped hover :items="client.projects" :fields="[
						{
							key: 'libelle',
							label: 'Nom',
							sortable: true
						},
						{
							key: 'last_treatment',
							label: 'Date du dernier traitement',
							sortable: true,
							sortByFormatted: true,
							formatter: (value, key, item) => {
								return item.last_treatment ? item.last_treatment.dateheure_debut : 0;
  							},
						},
						{
							key: 'scenario',
							label: 'Scenario',
							sortable: true,
							sortByFormatted: true,
							formatter: (value, key, item) => {
								return item.scenario ? true : false;
  							},
						}
					]">
						<template v-slot:cell(last_treatment)="data">
							<span>{{data.item.last_treatment ? moment(data.item.last_treatment.dateheure_debut).format("LL") : ""}}</span>
						</template>
						<template #cell(index)="data">
							<i class="fa fa-times close" @click="remove_mapping(data.index)"></i>
						</template>
						<template #cell(scenario)="data">
							<span>{{(data.item && data.item.scenario) ? "oui" : "non"}}</span>
						</template>
					</b-table>
				</div>
			</div> 
		</div>

		<!-- <pre>{{clients}}</pre> -->
    </div>

</template>

<script>
	import moment from "moment";
	require('moment/locale/fr')

	import store from "../store.js";

	import service_treatments from "../services/treatments.js";
	import service_projects from "../services/projects.js";
	import service_scenario from "../services/scenario.js";
	import service_clients from "../services/client.js";
	import BarChart from "../services/BarChart.vue";

	export default {
		name: "global_stats",
        components: {
			BarChart
        },
		data: function () {
			return {
				client: null,
				clients: [],
				clients_name: [],
				print: false,
				steps: null,
				steps_scenario: null,
				steps_obj: {},
				steps_scenario_obj: {},
				bandwidth: null,
				editor_bandwidth: null,
				bandwidth_sum: 0,
				editor_bandwidth_sum: 0
			};
		},
		methods: {
			generate_last_treatments: function()
			{
				service_projects.generate_last_treatments()
			},
			name_libelle : function(action)
			{
				var libelles = {
					"opérations sur colonnes": "Fonction sur colonne",
					"nettoyage": "Normalisation",
					"chercher et classer": "Chercher et classer",
					"referentiel": "Référentiel",
					"supprimer lignes": "Supprimer lignes",
					"fusionner lignes": "Fusionner lignes",
					"deux points": "Deux points",
					"split": "Split",
					"split_json": "Split json",
					"sort": "Sort",
					"sequence": "Séquences",
					"mapping colonnes": "Mapping colonnes",
					"mapping colonnes - fichier cible": "Mapping colonnes - fichier",
					"correspondance": "Correspondance",
					"conversion": "Conversion",
					"base de données": "Base de données",
					"share_document": "Partage de document",
					"ftp": "FTP",
					"projet": "Projet",
					"hit parade": "Hit parade",
					"textrazor": "Textrazor",
					"transkate": "Traduction",
					"scraping": "Scraping",
					"siren": "Siren",
					"insee": "Insee",
					"html": "Générer document",
					"mail": "Envoi de mail",
					"docx": "Docx",
					"ocr": "Ocr",
					"abbyy": "Abbyy",
					"vision": "Ocr - Google Vision",
					"airtable": "Airtable",
					"n8n": "N8n",
					"fonction": "Script personnalisé",
					"chercher et remplacer": "Mode regex",
					"api": "API",
					"file": "Fichier",
					"pdf": "Pdf",
					"user_details": "Profil utilisateur",
					"send_notifications": "Notifications",
					"pdf_extract": "Analyse pdf - étape 1",
					"zone_extract": "Analyse pdf - étape 2",
					"zone_final_extract": "Analyse pdf - étape 3",
					"split_zone": "Analyse pdf - découpe de document",
					"xlsx": "xlsx",
					"zip": "Zip"
				}

				return libelles[action] || "";
			},
			name_worker : function(action)
			{
				switch (action)
				{
					case "ftp":
						return "ftp";
					case "airtable":
						return "api";
					case "siren":
						return "api";
					case "base de données":
						return "database";
					case "hit parade":
						return "stats";
					case "send_notifications":
						return "user";
					case "textrazor":
						return "textrazor";
					case "translate":
						return "translate";
					case "correspondance":
						return "compare_csv"; 
					case "projet":
						return "projet";
					case "user":
						return "user";
					case "user_details":
						return "user";
					case "pdf_extract":
						return "pdf_html";
					case "html":
						return "html";
					case "insee":
						return "insee";
					case "api":
						return "api";
					case "docx":
						return "docx";
					case "xlsx":
						return "csv_to_xlsx";
					case "scraping":
						return "scrapping";
					case "share_document":
						return "document";
					case "mail":
						return "mail";
					case "zip":
						return "zip";
					case "zone_extract":
						return "zone_extract";
					case "zone_final_extract":
						return "zone_final_extract";
					case "split_zone":
						return "split_zone";
					case "ocr":
						return "ocr";
					case "abbyy":
						return "abbyy";
					case "vision":
						return "vision";
					case "file":
						return "file";
					case "pdf":
						return "pdf";
					default:
						return "csv";
				}
			},
            isAdmin: function() {
                return store.getters.isAdmin;
			},
			async getProjectInfos(project)
			{
				project.last_treatment = await service_treatments.getAllId(project.uid, 0, 1, null)
				project.steps = await service_projects.getSteps(project.uid)
				for (var i = 0; i < project.steps.length; i++)
				{
					project.steps[i] = project.steps[i].etape_id;
				}
				if (project.details && project.details.scenario)
				{
					var scenario = await service_scenario.getby_id(project.details.scenario)
					scenario = scenario[0];
					if (scenario)
					{
						project.scenario = scenario.uid;
						project.steps_scenario = [];
						for (let i = 0; i < scenario.structure.length; i++)
						{
							project.steps_scenario.push(scenario.structure[i].action);
							if (this.steps_scenario_obj[scenario.structure[i].action])
								this.steps_scenario_obj[scenario.structure[i].action]++;
							else
								this.steps_scenario_obj[scenario.structure[i].action] = 1;
							project.steps.push(this.name_worker(scenario.structure[i].action));
						}
					}
					for (let i = 0; i < project.steps.length; i++)
					{
						if (this.steps_obj[project.steps[i]])
							this.steps_obj[project.steps[i]]++;
						else
							this.steps_obj[project.steps[i]] = 1;
					}
				}

				delete project.details;
			},
			async getProjects(client_uid)
			{
				var projects = await service_projects.getAll(true, false, client_uid)

				for (var i = 0; i < projects.length; i++)
				{
					console.log(i + "/" + projects.length)
					await this.getProjectInfos(projects[i]);
				}

				console.log(projects)

				return projects;
			},
			async getClients()
			{
				var self = this;
				this.print = 0;

				await new Promise((resolve, reject) => {
					self.$nextTick(async function () {
						resolve();
					});
				});

				this.steps_obj = [];
				this.steps_scenario_obj = [];

				if (this.client == "all")
				{
					for (var i = 0; i < this.clients.length; i++)
					{
						this.clients[i].projects = await this.getProjects(this.clients[i].uid)
					}
				}
				else
				{
					for (var i = 0; i < this.clients.length; i++)
					{
						if (this.client == this.clients[i].uid)
							this.clients[i].projects = await this.getProjects(this.clients[i].uid)
						else
							this.clients[i].projects = null
					}
				}


				this.steps = [];
				this.steps_scenario = [];

				var keys = Object.keys(this.steps_obj);
				for (var i = 0; i < keys.length; i++)
				{
					this.steps.push({name: keys[i], value: this.steps_obj[keys[i]]})
				}

				var keys = Object.keys(this.steps_scenario_obj);
				for (var i = 0; i < keys.length; i++)
				{
					this.steps_scenario.push({
						name: keys[i], 
						studio_name: this.name_libelle(keys[i]),
						value: this.steps_scenario_obj[keys[i]],
						worker: this.name_worker(keys[i])
					})
				}

				this.print = true;
			}
		},
		mounted: async function () {
			
			if (!this.isAdmin())
			{
				this.$router.push({ name: "profile" });
			}

			this.clients = await service_clients.getClients();

			this.steps_obj = {};
			this.steps_scenario_obj = {};

			for (var i = 0; i < this.clients.length; i++)
			{
				if (this.clients[i].archive)
				{
					this.clients.splice(i, 1)
					i--;
				}
			}

			this.clients_name.push({
				value: "all",
				text: "Tous les clients"
			})
			for (var i = 0; i < this.clients.length; i++)
			{
				delete this.clients[i].details;
				this.clients_name.push({
					value: this.clients[i].uid,
					text: this.clients[i].nom
				})
			}

			var data = await service_clients.getBandwidth(true);
				var values = [];

				for (var i = 0; i < data.length; i++) 
				{
					values.push({x: new Date(data[i].date), y: data[i].compteur});
					this.bandwidth_sum += parseFloat(data[i].compteur);
				}

			this.bandwidth = {
				datasets: [
					{
						fill: false,
						label: "Bande passante (mo) - traitements",
						data: values,
						backgroundColor: "#0000ff"
					},
				]
			};

			var data = await service_clients.getEditorBandwidth(true);
			var values = [];

			for (var i = 0; i < data.length; i++) 
			{
				values.push({x: new Date(data[i].date), y: data[i].compteur});
				this.editor_bandwidth_sum += parseFloat(data[i].compteur);
			}

			this.editor_bandwidth = {
				datasets: [
					{
						fill: false,
						label: "Bande passante (mo) - editeur de scénario",
						data: values,
						backgroundColor: "#0000ff"
					},
				]
			};
		},
	};
</script>
